import _ from "underscore";
import rison from "rison";
import { InspectionType } from "./inspectionHelper";
import SubnavigationBaseView from "../subnavigationBaseView";
import pageHTML from "./subnavigation.tmpl";

    export default class InspectionSubMenu extends SubnavigationBaseView {
        private readonly template = _.template(pageHTML);
        private readonly activeMenu: "hosMain" | "dvirMain";
        private language: string;

        constructor (options) {
            super(options);
            this.activeMenu = options.activeMenu;
            this.language = options.language;
        }

        /* eslint-disable @typescript-eslint/unbound-method */
        events() {
            return {
                "click #inspection-hosMain": this.navigateHos,
                "click #inspection-dvirMain": this.navigateDvir
            } as Backbone.EventsHash;
        }
        /* eslint-enable @typescript-eslint/unbound-method */

        switchLanguage (language: string) {
            if (this.language !== language) {
                this.language = language;
                this.render();
            }
        }

        render () {
            if (!this.app.store.getState().mobile.embed) {
                void this.display(this.template({active: this.activeMenu}), this.language);
            }
            return this;
        }

        private navigateHos () {
            this.app.router.navigate(`inspection/main,${ rison.encode({ type: InspectionType.HOS_MAIN }) }`, true);
        }

        private navigateDvir () {
            this.app.router.navigate(`inspection/main,${ rison.encode({ type: InspectionType.DVIR_MAIN }) }`, true);
        }
    }